module.exports = __webpack_public_path__ + "static/media/cert_134.0287b381.jpg";